import {
  Cherry,
  Cog,
  HeartPulse,
  House,
  LogOut,
  MessageSquareDot,
  TicketCheck,
} from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../common/sheet";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import { ScrollArea, ScrollBar } from "../scroll-area";
import { ProfilePicture } from "../common/ProfilePicture";
import { MobileNavButton } from "./mobile-sidebar-nav";
import { LogOutDialog } from "../log-out-dialog";
import { useSelector } from "react-redux";
import { customerName } from "../../../store/customerSlice";
import LoyaltyIcon from "@mui/icons-material/Loyalty";

export const MobileSidebar = ({ children }) => {
  const name = useSelector(customerName);

  const dashboardSidebarButtons = [
    {
      name: "Home",
      icon: <House className="size-4" />,
      link: "/home",
    },
    {
      name: "My Health Report",
      icon: <HeartPulse className="size-4" />,
      link: "/health-report",
    },
    {
      name: "My Counselling",
      icon: <Diversity1OutlinedIcon className="size-3" />,
      link: "/counselling",
    },
    {
      name: "My Subscriptions",
      icon: <TicketCheck className="size-4" />,
      link: "/my-subscriptions",
    },
    {
      name: "My Nutrients",
      icon: <Cherry className="size-5" />,
      link: "https://supple.nhwm.in/",
    },
    {
      name: "Explore Plans",
      icon: <LoyaltyIcon className="size-3" />,
      link: "/plans",
    },
    {
      name: "Notifications",
      icon: <MessageSquareDot className="size-4" />,
      link: "/notification",
    },
    {
      name: "My Account",
      icon: <Cog className="size-4" />,
      link: "/account-settings",
    },
  ];

  return (
    <Sheet>
      <SheetTrigger>{children}</SheetTrigger>
      <SheetContent side="left">
        <SheetHeader>
          <SheetTitle>My Profile</SheetTitle>
        </SheetHeader>
        <hr />
        <ScrollArea className="h-[90dvh]">
          <div className="flex flex-col justify-between h-full">
            <div className="h-full">
              <section className="flex flex-col items-center py-3">
                <div className="flex flex-col items-center justify-center gap-y-3 ">
                  <div className="border-1 border-slate-400 rounded-full">
                    <ProfilePicture className="size-8" />
                  </div>
                  <div className="text-xs font-medium uppercase">{name}</div>
                </div>
              </section>
              <section className="flex flex-col gap-1">
                {dashboardSidebarButtons.map((button) => {
                  return (
                    <MobileNavButton
                      key={button.link}
                      route={button.link}
                      Icon={button.icon}
                    label={button.name}
                    />
                  );
                })}
              </section>
              <div className="flex items-center justify-center mt-12 text-red-500 bg-red-50 rounded-xl px-2 py-1 w-full">
                <LogOutDialog>
                    <span className="flex gap-2 items-center text-sm  text-center">
                      Logout
                      <LogOut className="size-3.5"/>
                    </span>
                </LogOutDialog>
              </div>
            </div>
            <div className="mt-4">
              <div className="flex flex-col items-center justify-center mt-4">
                <p className="mb-1 text-xs text-[#307bc4] text-center">
                  Need any Assistance?
                </p>
                <p className="mb-1 text-xs text-[#307bc4] text-center">
                  Contact Us:
                </p>
                <p className="mb-1 text-xs text-[#307bc4] text-center">
                  <a href="tel:+913614516663">+91 3614516663 (Call)</a>
                </p>
                <p className="mb-1 text-xs text-[#307bc4] text-center">
                  <a href="tel:+913614516663">+91 9707998887 (WA & Call)</a>
                </p>
                <p className="mb-1 text-xs text-[#307bc4] text-center">
                  <a href="tel:+913614516663">+91 9707076232 (WA & Call)</a>
                </p>
              </div>
            </div>
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};
